import { render, staticRenderFns } from "./RcvPD.vue?vue&type=template&id=2dc9c53a"
import script from "./RcvPD.vue?vue&type=script&lang=js"
export * from "./RcvPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports